<template>
  <b-list-group-item
    :variant="isSelected ? 'primary' : null"
    class="student-card curved-border mt-1"
    @click="toggleStudent"
  >
    <div class="d-flex align-items-center">
      <b-avatar
        v-if="student.photo"
        :src="`${$store.getters['auth/storageUrl']}/${student.photo}`"
        size="40"
        class="mr-3"
      />
      <b-avatar
        v-else
        :text="getInitials(student.first_name, student.last_name)"
        size="40"
        variant="primary"
        class="mr-3"
      />
      
      <div class="flex-grow-1">
        <div class="font-weight-bold">{{ student.full_name }}</div>
        <small class="text-gray">
          {{ student.student_id }}
          <span v-if="student.class_name"> • {{ student.class_name }}</span>
        </small>
      </div>
      
      <!-- Toggle Icon -->
      <div class="toggle-icon">
        <feather-icon
          v-if="isSelected"
          icon="CheckCircleIcon"
          size="18"
          class="text-success cursor-pointer"
        />
        <feather-icon
          v-else
          icon="XIcon"
          size="18"
          class="text-danger cursor-pointer"
        />
      </div>
    </div>
  </b-list-group-item>
</template>

<script>
import {
  BListGroup, BListGroupItem, BAvatar,
} from 'bootstrap-vue'

export default {
  name: 'StudentCard',
  components: {
    BListGroup,
    BListGroupItem,
    BAvatar,
  },
  props: {
    student: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getInitials(firstName, lastName) {
      const first = firstName ? firstName.charAt(0).toUpperCase() : ''
      const last = lastName ? lastName.charAt(0).toUpperCase() : ''
      return first + last
    },
    toggleStudent() {
      this.$emit('select', this.student)
    }
  }
}
</script>

<style scoped>
.student-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.student-card:hover {
  background-color: var(--bs-gray-100);
}

.curved-border {
  border: 1px solid #fa2;
  padding: 10px;
  border-radius: 10px;
}

.cursor-pointer {
  cursor: pointer;
}

.toggle-icon {
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.toggle-icon:hover {
  background-color: var(--bs-gray-200);
}
</style> 